import React, { useEffect, useState, createRef } from "react";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

//API
import fiscalizacao_api from "../../../../api/fiscalizacao_api";
import formulario_api from "../../../../api/formulario_api";
import tipoDeFiscalizacao_api from "../../../../api/tipoDeFIscalizacao_api";
import integracao_api from "../../../../api/integracao_api";

//Helpers
import { showMessage } from "../../../../helpers/message";
import { distanciaEntreDuasCoordenadas } from "../../../../helpers/mapas";
import uuid from "../../../../helpers/guid";
import { objCampo, validarCampos } from "../../../../helpers/ValidadorDeCampos";
import mascaras from "../../../../helpers/mascaras";

//Context
import { useAuth } from "../../../../context/auth";

//Components
import MainCard from "../../../../components/MainCard";
import Identificacao from "./Identificacao";
import FormularioFiscalizacao from "./FormularioFiscalizacao";
import Stepper from "../../../../components/Stepper";
import MapaDeCacambas from "./MapaDeCacambas";
import Codigo from "./Codigo";
import solicitacaoFiscalizacao_api from "../../../../api/solicitacaoFiscalizacao_api";
import ModalCustomized from "../../../../components/Modal/Modal";
import TabelaListagem from "../../../../components/TabelaListagem/TabelaListagem";

//Constants
import { actionsTable } from "../../../../constants/MaterialTable";

function initialStateRespostas(
  fiscalizacao = {},
  tipoFiscalizacao = {},
  hash,
  formulario,
  avulso
) {
  //Pegando o id do tipo de serviço e a identificação do tipo de fiscalização
  const tipoFiscalizacaoServico_Id = fiscalizacao
    ? fiscalizacao?.tipoFiscalizacaoServico_Id
    : tipoFiscalizacao.tipoFiscalizacaoServico_Id
      ? tipoFiscalizacao.tipoFiscalizacaoServico_Id
      : "";
  const tipoFiscalizacaoIdentificacao = fiscalizacao
    ? fiscalizacao.tipoFiscalizacao_Descricao
    : tipoFiscalizacao.identificacao
      ? tipoFiscalizacao.identificacao
      : "";

  //Condição para que os campos de endereço apareçam na identificação
  const indicarEnderecoCondition =
    avulso == true || tipoFiscalizacao?.indicarEndereco == "Manual"
      ? true
      : false;

  let logradouro = "";

  if (fiscalizacao && !!fiscalizacao?.logradouro) {
    const _logradouro = fiscalizacao?.logradouro.split(",");
    logradouro =
      _logradouro.length > 1
        ? _logradouro[0].trim()
        : fiscalizacao?.logradouro?.trim();
  }

  //Dados do infrator
  const infrator = {
    infrator_Id: null,
    documentoIdentificacao: "",
    nomeRazao: "",
    nomeFantasia: "",
    email: "",
    codigoCadastro: "",
    cep_Infrator: "",
    logradouro_Infrator: "",
    bairro_Infrator: "",
    numeroLogradouro_Infrator: "",
    complemento_Infrator: "",
    cidade_Infrator: "",
    uf_Infrator: "",
  };

  return {
    tipoFiscalizacaoServico_Id,
    tipoFiscalizacaoIdentificacao,
    tipoFiscalizacao_Id: fiscalizacao?.tipoFiscalizacao_Id ?? "",
    solicitacaoFiscalizacao_Id: fiscalizacao ? fiscalizacao.id : null,
    tipoSincronizacao: "Fiscalizacao",
    latitude:
      fiscalizacao && fiscalizacao.latitude ? fiscalizacao.latitude : "",
    longitude:
      fiscalizacao && fiscalizacao.longitude ? fiscalizacao.latitude : "",
    assinaturaInfratorBase64: "",
    dataFiscalizacao: indicarEnderecoCondition
      ? ""
      : moment().format("YYYY-MM-DD HH:mm"),
    hash,
    codigoItemFiscalizado:
      fiscalizacao && fiscalizacao.codigoItemFiscalizado
        ? fiscalizacao.codigoItemFiscalizado
        : "",
    id_Retorno: 0,
    entidadeFiscalizada: "",
    agrupamentos: [],
    emailsCC: [],
    indicarEndereco: indicarEnderecoCondition ? "Manual" : "Automático",
    cep: fiscalizacao && fiscalizacao.cep ? fiscalizacao.cep : "",
    logradouro: logradouro,
    bairro: fiscalizacao && fiscalizacao.bairro ? fiscalizacao.bairro : "",
    numeroLogradouro:
      fiscalizacao && fiscalizacao.numero ? fiscalizacao.numero : "",
    cidade: fiscalizacao && fiscalizacao.cidade ? fiscalizacao.cidade : "",
    uf: fiscalizacao && fiscalizacao.uf ? fiscalizacao?.uf : "",
    complemento:
      fiscalizacao && fiscalizacao.complemento ? fiscalizacao.complemento : "",
    regional_Id:
      fiscalizacao && fiscalizacao.regional_Id
        ? fiscalizacao.regional_Id?.toString()
        : "",
    dataFlagrande: fiscalizacao?.dataFlagrande
      ? moment(fiscalizacao.dataFlagrande).format("YYYY-MM-DD HH:mm:ss")
      : "",
    infrator,
    formulario: [
      ...(formulario
        ? formulario.formularioQuestoes.map((value) => {
          return {
            formularioQuestao_Id: value.id,
            capturarFotoRef: createRef(),
            valor: "",
            anexos: [],
          };
        })
        : []),
    ],
  };
}

function ExecucaoFiscalizacaoStepper({
  solicitacaoFiscalizacao = null,
  avulso = false,
  handleVoltar,
}) {
  const { setLoading } = useAuth();

  //Estado de controle do passo ativo
  const [activeStep, setActiveStep] = useState(1);

  //Estado para criar/editar solicitação fiscalização
  const [execucaoFiscalizacao, setExecucaoFiscalizacao] = useState(
    initialStateRespostas({}, {}, uuid(), null, avulso)
  );

  //Estado para guarda a lista de veículos com mesma placa
  const [listaItensIntegracoes, setListaItensIntegracoes] = useState([]);

  //Estado de controle do tipo de fiscalização
  const [tipoFiscalizacao, setTipoFiscalizacao] = useState(null);

  //Estado que guarda os tipos de fiscalização
  const [tiposFiscalizacao, setTiposFiscalizacao] = useState([]);

  //Campos obrigatorios da tela de codigo
  const camposCodigo = [
    objCampo({ name: "tipoFiscalizacao_Id", required: true }),
    objCampo({ name: "tipoFiscalizacaoServico_Id", required: true }),
    ...(tipoFiscalizacao?.integracoes?.length > 0
      ? [objCampo({ name: "codigoItemFiscalizado", required: true })]
      : []),
  ];

  //Estado de controle de visibilidade do modal
  const [visibleModal, setVisibleModal] = useState(false);
  const toggleModal = () => setVisibleModal(!visibleModal);

  //Variavel que guarda os steps para o fluxo de integração de pesquisa e fluxo sem integração
  const stepsPesquisaEComIntegracao = [
    { text: "Identificação do Infrator" },
    { text: "Formulário de Fiscalização" },
  ];

  //Variavel que guarda os steps para o fluxo de integração de pesquisa e fluxo sem integração
  const stepsPesquisaESemIntegracao = [
    { text: "Codigo" },
    { text: "Identificação do Infrator" },
    { text: "Formulário de Fiscalização" },
  ];

  //Variavel que guarda o fluxo para integração de mapa com codigo de item e idRetorno
  const stepsIntegracaoMapaComCodigo = [
    { text: "Identificação do Infrator" },
    { text: "Formulário de Fiscalização" },
  ];

  //Variavel que guarda o fluxo para integração de mapa sem codigo
  const stepsIntegracaoMapaSemCodigo = [
    { text: "Mapa de caçambas" },
    { text: "Formulário de Fiscalização" },
  ];

  //Variavel que guarda o fluxo para integração de mapa sem codigo e com a opção de indicar endereço ativa
  const stepsIntegracaoMapaSemCodigoEComIndicarEndereco = [
    { text: "Mapa de caçambas" },
    { text: "Identificação do Infrator" },
    { text: "Formulário de Fiscalização" },
  ];

  const [disabledCamposDadosFalecido, setDisabledCamposDadosFalecido] =
    useState({
      nome: false,
      cpf: false,
      dataFalecimento: false,
      dataNascimento: false,
    });

  //Estado de controle de erros na tela
  const [errors, setErrors] = useState({});

  //Estado para pegar o formulario
  const [formulario, setFormulario] = useState(null);

  //Estado que guarda os dados da integração
  const [dadosIntegracao, setDadosIntegracao] = useState(null);

  //Estado que guarda os pontos do mapa carregados pela integração
  const [pontosMapa, setPontosMapa] = useState([]);

  //Estado de controle de visibilidade dos botões do stepper
  const [showButtons, setShowButtons] = useState(true);

  //Passos do cadastro da fiscalização
  const [steps, setSteps] = useState(stepsPesquisaESemIntegracao);

  //Estado de controle de exibição dos campos de endereço caso não seja retornado latitude e longitude da integracao
  const [indicarEndereco, setIndicarEndereco] = useState(false);

  //Estado para pegar as images da solicitação
  const [solicitacaoImages, setSolicitacaoImages] = useState([]);

  //Estado para guarda se é para exbir card de dados de óbito ou não
  const [exibirDadosObitor, setExibirDadosObitor] = useState(false);

  //Cabeçalhos da lista de veiculo com mesma placa
  const headers = [
    { objectValue: "documentoIdentificacao", value: "CNPJ", col: "12" },
    { objectValue: "nomeFantasia", value: "FANTASIA", col: "12" },
  ];

  //Função que valida os campos da tela de codigo
  const validarCodigo = () => {
    let _camposCodigo = [...camposCodigo];

    if (tipoFiscalizacao)
      _camposCodigo = _camposCodigo.filter(
        (value) => value.name == "codigoItemFiscalizado"
      );

    const _errors = validarCampos(execucaoFiscalizacao, _camposCodigo);
    //Caso todos os campos estejam preenchidos é feito o carregamento da integração
    if (_errors[1].length === 0)
      loadIntegracaoPesquisa(
        execucaoFiscalizacao.codigoItemFiscalizado,
        tipoFiscalizacao,
        true
      );

    setErrors(_errors[0]);
    return true;
  };

  //Função que valida a identificação
  const validarIdentificacao = () => {
    const camposIdentificacaoInfrator = [
      objCampo({ name: "documentoIdentificacao", required: true }),
      objCampo({ name: "email", required: true }),
      objCampo({ name: "nomeRazao", required: true }),
      objCampo({ name: "nomeFantasia", required: true }),
      objCampo({ name: "cep_Infrator", required: true }),
      objCampo({ name: "cidade_Infrator", required: true }),
      objCampo({ name: "uf_Infrator", required: true }),
      objCampo({ name: "logradouro_Infrator", required: true }),
      objCampo({ name: "bairro_Infrator", required: true }),
      objCampo({ name: "numeroLogradouro_Infrator", required: true }),
    ];
    const camposIdentificacao = [];

    if (avulso) {
      camposIdentificacao.push(
        ...[
          objCampo({ name: "cep", required: true }),
          objCampo({ name: "cidade", required: true }),
          objCampo({ name: "uf", required: true }),
          objCampo({ name: "logradouro", required: true }),
          objCampo({ name: "bairro", required: true }),
        ]
      );
    }

    camposIdentificacao.push(objCampo({ name: "dataFiscalizacao", required: true }));
    camposIdentificacao.push(objCampo({ name: "regional_Id", required: true }));

    const _errors = validarCampos(execucaoFiscalizacao, camposIdentificacao);
    const _errorsInfrator = validarCampos(
      execucaoFiscalizacao.infrator,
      camposIdentificacaoInfrator
    );
    setErrors({ ..._errors[0], ..._errorsInfrator[0] });
    return [..._errors[1], ..._errorsInfrator[1]];
  };

  //Função de validação do formulario
  const validarFormulario = () => {
    const questoesObrigatorias = formulario.formularioQuestoes.filter(
      (questao) => questao.obrigatorio
    );
    const questoesRespondidas = execucaoFiscalizacao.formulario.filter(
      (value) => !!value.valor
    );

    if (
      questoesObrigatorias.some(
        (questao) =>
          !questoesRespondidas.some(
            (respondida) => questao.id == respondida.formularioQuestao_Id
          )
      ) ||
      questoesObrigatorias.some((questao) =>
        questoesRespondidas.some(
          (respondida) =>
            questao.id === respondida.formularioQuestao_Id &&
            questao.tirarFoto === "Obrigatorio" &&
            respondida.anexos.length === 0
        )
      )
    ) {
      setErrors(true);
      return true;
    }
    return false;
  };

  //Função para carregar os formulários
  async function loadFormulario(
    _tipoFiscalizacao = { ...tipoFiscalizacao },
    dadosIntegracao,
    _formulario = formulario
  ) {
    const formularioAtual = _formulario ?? formulario;

    if (
      formularioAtual &&
      _tipoFiscalizacao.formulario_Id === formularioAtual.id
    ) {
      if (dadosIntegracao) {
        const _execucaoFiscalizacao = {
          ...initialStateRespostas(
            solicitacaoFiscalizacao,
            _tipoFiscalizacao,
            uuid(),
            formularioAtual,
            avulso
          ),
        };
        if (execucaoFiscalizacao.tipoFiscalizacao_Id)
          _execucaoFiscalizacao.tipoFiscalizacao_Id =
            execucaoFiscalizacao.tipoFiscalizacao_Id;
        if (execucaoFiscalizacao.tipoFiscalizacaoServico_Id)
          _execucaoFiscalizacao.tipoFiscalizacaoServico_Id =
            execucaoFiscalizacao.tipoFiscalizacaoServico_Id;
        if (execucaoFiscalizacao.codigoItemFiscalizado)
          _execucaoFiscalizacao.codigoItemFiscalizado =
            execucaoFiscalizacao.codigoItemFiscalizado;

        const _novoEstadoSync = salvarDadosIntegracao(dadosIntegracao, _execucaoFiscalizacao);
        await preencherEnderecoInfrator(_novoEstadoSync);
        setExecucaoFiscalizacao(_novoEstadoSync);
      }
      return;
    }
    try {
      setLoading(true);
      const { data } = await formulario_api.getListApp(
        _tipoFiscalizacao.formulario_Id
      );

      if (!!data) {
        setFormulario((prev) => ({ ...data[0] }));
        const _execucaoFiscalizacao = {
          ...initialStateRespostas(
            solicitacaoFiscalizacao,
            _tipoFiscalizacao,
            uuid(),
            data[0],
            avulso
          ),
        };

        if (execucaoFiscalizacao.tipoFiscalizacao_Id)
          _execucaoFiscalizacao.tipoFiscalizacao_Id =
            execucaoFiscalizacao.tipoFiscalizacao_Id;
        if (execucaoFiscalizacao.tipoFiscalizacaoServico_Id)
          _execucaoFiscalizacao.tipoFiscalizacaoServico_Id =
            execucaoFiscalizacao.tipoFiscalizacaoServico_Id;
        if (execucaoFiscalizacao.codigoItemFiscalizado)
          _execucaoFiscalizacao.codigoItemFiscalizado =
            execucaoFiscalizacao.codigoItemFiscalizado;

        const _novoEstadoAsync = salvarDadosIntegracao(
          dadosIntegracao,
          _execucaoFiscalizacao,
          _tipoFiscalizacao
        );
        await preencherEnderecoInfrator(_novoEstadoAsync);
        setExecucaoFiscalizacao(_novoEstadoAsync);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  async function preencherEnderecoInfrator(estado) {
    const doc = estado?.infrator?.documentoIdentificacao;
    if (!doc || estado?.infrator?.cep_Infrator) return;
    try {
      const { data } = await integracao_api.GetInfratorIntegracao(doc);
      const addr = data?.[0];
      if (addr) {
        estado.infrator = {
          ...estado.infrator,
          cep_Infrator: addr.ceP_Infrator ?? "",
          logradouro_Infrator: addr.logradouro_Infrator ?? "",
          bairro_Infrator: addr.bairro_Infrator ?? "",
          numeroLogradouro_Infrator: addr.numeroLogradouro_Infrator ?? "",
          complemento_Infrator: addr.complemento_Infrator ?? "",
          cidade_Infrator: addr.cidade_Infrator ?? "",
          uf_Infrator: addr.uF_Infrator ?? "",
        };
      }
    } catch (_) {}
  }

  //Função que salva os dados da integraçao no state dados integracao e no state execucaofiscalizacao
  const salvarDadosIntegracao = (
    dadosIntegracao,
    execucaoFiscalizacao,
    _tipoFiscalizacao = { ...tipoFiscalizacao }
  ) => {
    let _dadosIntegracao =
      dadosIntegracao != null ? { ...dadosIntegracao } : {};
    _dadosIntegracao.dadosFalecido = null;

    if (_tipoFiscalizacao?.exibirDadosObito === true) {
      setExibirDadosObitor(true);

      _dadosIntegracao.dadosFalecido = {
        nome: _dadosIntegracao?.dadosObito?.falecido?.nome ?? "",
        cpf: _dadosIntegracao?.dadosObito?.falecido?.cpf
          ? _dadosIntegracao.dadosObito.falecido.cpf.replace(/\D/g, "")
          : "",
        dataNascimento: !!_dadosIntegracao?.dadosObito?.falecido?.dataNascimento
          ? moment(
            _dadosIntegracao.dadosObito.falecido.dataNascimento,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")
          : "",
        dataFalecimento: !!_dadosIntegracao?.dadosObito?.falecido
          ?.dataFalecimento
          ? moment(
            _dadosIntegracao.dadosObito.falecido.dataFalecimento,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")
          : "",
      };

      setDisabledCamposDadosFalecido({
        nome: !!_dadosIntegracao?.dadosFalecido?.nome,
        cpf: !!_dadosIntegracao?.dadosFalecido?.cpf,
        dataFalecimento: !!_dadosIntegracao?.dadosFalecido?.dataFalecimento,
        dataNascimento: !!_dadosIntegracao?.dadosFalecido?.dataNascimento,
      });

      if (_dadosIntegracao?.dadosObito) delete _dadosIntegracao.dadosObito;
    }

    setDadosIntegracao(_dadosIntegracao);
    //retornando os dados atualizados da execução da fiscalização
    return {
      ...execucaoFiscalizacao,
      id_Retorno: _dadosIntegracao.id_Retorno,
      entidadeFiscalizada: _dadosIntegracao.entidadeFiscalizada,
      emailsCC:
        _dadosIntegracao?.infratorEmailsCCs &&
          _dadosIntegracao?.infratorEmailsCCs.length > 0
          ? _dadosIntegracao?.infratorEmailsCCs
          : [],
      latitude: !_dadosIntegracao.latitude
        ? execucaoFiscalizacao.latitude
        : _dadosIntegracao.latitude,
      longitude: !_dadosIntegracao.longitude
        ? execucaoFiscalizacao.longitude
        : _dadosIntegracao.longitude,
      numeroLogradouro: solicitacaoFiscalizacao?.numero ?? "",
      infrator: {
        documentoIdentificacao: _dadosIntegracao.documentoIdentificacao,
        nomeRazao: _dadosIntegracao.nomeRazao,
        nomeFantasia: _dadosIntegracao.nomeFantasia,
        email: _dadosIntegracao.email,
        codigoCadastro: _dadosIntegracao.codigoCadastro,
        cep_Infrator:
          _dadosIntegracao && _dadosIntegracao.ceP_Infrator
            ? _dadosIntegracao.ceP_Infrator
            : "",
        logradouro_Infrator:
          _dadosIntegracao && _dadosIntegracao.logradouro_Infrator
            ? _dadosIntegracao.logradouro_Infrator
            : "",
        bairro_Infrator:
          _dadosIntegracao && _dadosIntegracao.bairro_Infrator
            ? _dadosIntegracao.bairro_Infrator
            : "",
        numeroLogradouro_Infrator:
          _dadosIntegracao && _dadosIntegracao.numeroLogradouro_Infrator
            ? _dadosIntegracao.numeroLogradouro_Infrator
            : "",
        complemento_Infrator:
          _dadosIntegracao && _dadosIntegracao.complemento_Infrator
            ? _dadosIntegracao.complemento_Infrator
            : "",
        cidade_Infrator:
          _dadosIntegracao && _dadosIntegracao.cidade_Infrator
            ? _dadosIntegracao.cidade_Infrator
            : "",
        uf_Infrator:
          _dadosIntegracao && _dadosIntegracao.uF_Infrator
            ? _dadosIntegracao.uF_Infrator
            : "",
      },
      dadosFalecido: _dadosIntegracao.dadosFalecido,
    };
  };

  //Função que carrega o tipo de fiscalizacao
  const loadTipoFiscalizacao = (tipoFiscalizacao_Id = null) => {
    if (tipoFiscalizacao_Id) {
      setLoading(true);
      tipoDeFiscalizacao_api
        .getListApp(tipoFiscalizacao_Id)
        .then(async (response) => {
          const _data = response.data[0];
          setTipoFiscalizacao((prev) => ({ ..._data }));
          //e se essa solicitação de fiscalizacao possuir integração do tipo mapa de pontos
          if (
            solicitacaoFiscalizacao &&
            _data.integracoes.some((x) => x.tipoIntegracao === "Mapa de Pontos")
          )
            loadIntegracaoMapa(_data);
          else if (
            solicitacaoFiscalizacao &&
            solicitacaoFiscalizacao.codigoItemFiscalizado &&
            _data.integracoes.some((x) => x.tipoIntegracao === "Pesquisa")
          ) {
            loadIntegracaoPesquisa(
              solicitacaoFiscalizacao.codigoItemFiscalizado,
              _data
            );
            setSteps([...stepsPesquisaEComIntegracao]);
          } else setLoading(false);
        })
        .catch((err) =>
          showMessage(
            "Error",
            err?.message ?? "Error na operação.",
            "error",
            null
          )
        );
    }
  };

  //Função que carrega  a integração de mapa
  const loadIntegracaoMapa = (_tipoFiscalizacao) => {
    integracao_api
      .getMapa({
        integracao_Id: _tipoFiscalizacao.integracoes.filter(
          (x) => x.tipoIntegracao == "Mapa de Pontos"
        )[0].integracao_Id,
        latitude: solicitacaoFiscalizacao.latitude,
        longitude: solicitacaoFiscalizacao.longitude,
        entidade: solicitacaoFiscalizacao.entidadeFiscalizada,
        id_retorno: solicitacaoFiscalizacao.id_Retorno,
      })
      .then((response) => {
        if (
          solicitacaoFiscalizacao.entidadeFiscalizada &&
          solicitacaoFiscalizacao.id_Retorno
        ) {
          if (response.data.length > 0) {
            loadFormulario(_tipoFiscalizacao, response.data[0]);
            setSteps([...stepsIntegracaoMapaComCodigo]);
          }
          //Caso não tenha sido retornado nada da integração é retornado a mensagem
          else
            throw new Error(
              "Não foi possível carregar os dados do item através da integração"
            );
        } else {
          //Caso algo tenha sido retornado da integração é setado os dados da integração
          loadListaPontosProximos(response.data);
          if (_tipoFiscalizacao.indicarEndereco == "Manual") {
            setSteps([...stepsIntegracaoMapaSemCodigoEComIndicarEndereco]);
          } else {
            setSteps([...stepsIntegracaoMapaSemCodigo]);
          }
          setShowButtons(false);
        }
      })
      .catch((e) =>
        showMessage("Error", e?.message ?? "Error na operação.", "error", null)
      )
      .finally((f) => setLoading(false));
  };

  async function loadNovoTipoFiscalizacao() {
    try {
      setLoading(true);

      const { data: dataFormulario } = await formulario_api.getListApp(
        tipoFiscalizacao.formulario_Id
      );
      const novoFormulario = dataFormulario?.[0];

      if (!novoFormulario) return;

      setFormulario((prevState) => ({ ...prevState, ...novoFormulario }));

      const _execucaoFiscalizacao = {
        ...initialStateRespostas(
          execucaoFiscalizacao,
          tipoFiscalizacao,
          execucaoFiscalizacao.hash,
          novoFormulario,
          avulso
        ),
      };

      loadFormulario(tipoFiscalizacao, _execucaoFiscalizacao, novoFormulario);

      setActiveStep((prev) => prev + 1);
      setIndicarEndereco(true);
    } catch (err) {
      showMessage("Erro", err?.message ?? "Erro na operação.", "error");
    } finally {
      setLoading(false);
    }
  }

  // Função que carrega a integração de pesquisa
  const loadIntegracaoPesquisa = async (
    codigoItem,
    _tipoFiscalizacao = { ...tipoFiscalizacao },
    avancarStep = false
  ) => {
    const integracaoPesquisa = _tipoFiscalizacao.integracoes.find(
      (x) => x.tipoIntegracao === "Pesquisa"
    );

    if (integracaoPesquisa && codigoItem) {
      try {
        setLoading(true);

        const { data } = await integracao_api.BuscarCodigoItem({
          integracao_Id: integracaoPesquisa.integracao_Id,
          codigo: codigoItem,
        });

        if (data && data.length > 1) {
          setListaItensIntegracoes(data);
          toggleModal();
        } else {
          const _data = data?.[0] ?? null;
          setExibirDadosObitor(_tipoFiscalizacao?.exibirDadosObito ?? false);

          loadFormulario(_tipoFiscalizacao, _data);

          if (avancarStep) setActiveStep((prev) => prev + 1);
          if (!_data?.latitude && !_data?.longitude) {
            setIndicarEndereco(true);
          }
        }
      } catch (error) {
        showMessage(
          "Aviso",
          "O item não foi localizado no sistema integrado, você terá que preencher manualmente as informações.",
          "warning",
          loadNovoTipoFiscalizacao
        );
      } finally {
        setLoading(false);
      }
    } else await loadNovoTipoFiscalizacao();

    setShowButtons(true);
  };

  //Função responsavel por agrupar os pontos da integração de mapa que estão mais proximos para que sejam exibidos em uma lista
  const loadListaPontosProximos = (integracao) => {
    let _listaIntegracoes = [...integracao];
    const listaCacambasAgrupadas = [];

    //Convertendo o nome dos icones para ficar condizente com as bibliotecas de icones
    _listaIntegracoes = _listaIntegracoes.map((value) => {
      const _value = { ...value };
      _value.latitude = _value.latitude.replace(",", ".");
      _value.longitude = _value.longitude.replace(",", ".");
      //Renomeando o icone de acordo com as bibliotecas seguindo camelCase
      while (_value.nomeIcone.indexOf("-") != -1) {
        const indexLetraMaiuscula = _value.nomeIcone.indexOf("-") + 1;
        _value.nomeIcone =
          _value.nomeIcone.substring(0, indexLetraMaiuscula) +
          _value.nomeIcone[indexLetraMaiuscula].toUpperCase() +
          _value.nomeIcone.substring(indexLetraMaiuscula + 1);
        _value.nomeIcone = _value.nomeIcone.replace("-", "");
      }
      _value.nomeIcone =
        _value.nomeIcone[0].toUpperCase() + _value.nomeIcone.substring(1);
      if (_value.fonteIcone == "FontAwesome5")
        _value.nomeIcone = "fa" + _value.nomeIcone;
      else if (_value.fonteIcone == "Entypo")
        _value.nomeIcone = "Entypo" + _value.nomeIcone;

      return _value;
    });

    //Agrupando os pontos proximos no mapa
    while (_listaIntegracoes.length > 0) {
      const fiscalizacao = { ..._listaIntegracoes[0] };
      const listaFiscalizacoesProximas = _listaIntegracoes.filter((filter) => {
        return (
          distanciaEntreDuasCoordenadas(
            fiscalizacao.latitude,
            fiscalizacao.longitude,
            filter?.latitude,
            filter?.longitude
          ) <= 10
        );
      });

      if (listaFiscalizacoesProximas.length > 1) {
        fiscalizacao.nomeIcone = "EntypoPlus";
        fiscalizacao.corIcone = "#2ecc71";
        fiscalizacao.fonteIcone = "Entypo";
        fiscalizacao.lista = listaFiscalizacoesProximas;
      }

      listaCacambasAgrupadas.push(fiscalizacao);

      _listaIntegracoes = _listaIntegracoes.filter((filter) => {
        return (
          distanciaEntreDuasCoordenadas(
            fiscalizacao.latitude,
            fiscalizacao.longitude,
            filter?.latitude,
            filter?.longitude
          ) > 10
        );
      });
    }
    listaCacambasAgrupadas.unshift({
      latitude: solicitacaoFiscalizacao.latitude.replace(",", "."),
      longitude: solicitacaoFiscalizacao.longitude.replace(",", "."),
      nomeIcone: "EntypoTrafficCone",
      corIcone: "#f39c12",
      fonteIcone: "Entypo",
      solicitacaoFiscalizacao: true,
    });
    setPontosMapa(listaCacambasAgrupadas);
  };

  //Função que carrega a lista de tipos de fiscalização
  const loadTiposDeFiscalizacao = () => {
    setLoading(true);
    tipoDeFiscalizacao_api
      .getList()
      .then((response) => {
        setTiposFiscalizacao(
          response.data.map((value) => ({
            value: value.id.toString(),
            label: value.identificacao,
            permiteFiscalizacaoAvulsa: value.permiteFiscalizacaoAvulsa,
          }))
        );
      })
      .catch((ex) => showMessage("Aviso!", ex.message, "error", null))
      .finally((f) => setLoading(false));
  };

  const loadSolicitacaoImages = (solicitacaoFiscalizacao_Id) => {
    solicitacaoFiscalizacao_api
      .getSolicitacaoFiscalizacaoAnexos(solicitacaoFiscalizacao_Id)
      .then((response) => {
        setSolicitacaoImages(response.data);
      })
      .catch((ex) => showMessage("Aviso!", ex.message, "error", null));
  };

  useEffect(() => {
    if (solicitacaoFiscalizacao) {
      loadSolicitacaoImages(solicitacaoFiscalizacao.id);
      loadTipoFiscalizacao(solicitacaoFiscalizacao?.tipoFiscalizacao_Id);
    } else {
      loadTiposDeFiscalizacao();
    }
  }, []);

  //Função que sincroniza uma fiscalizacao
  const sincronizarFiscalizacao = (_execucaoFiscalizacao) => {
    setLoading(true);
    fiscalizacao_api
      .post(_execucaoFiscalizacao)
      .then((response) => {
        showMessage(
          "Sucesso!",
          "Sucesso ao salvar a fiscalização!",
          "success",
          handleVoltar
        );
      })
      .catch((ex) => showMessage("Aviso!", ex.message, "error", null))
      .finally((f) => setLoading(false));
  };

  //Função que envia a execução para a api
  const enviarFiscalizacao = () => {
    const questoesRespondidas = [
      ...execucaoFiscalizacao.formulario.filter((value) => !!value.valor),
    ];
    //removendo as referencias dos inputs de arquivo
    questoesRespondidas.map((value) => {
      delete value.capturarFotoRef;
    });

    const _execucaoFiscalizacao = {
      ...execucaoFiscalizacao,
      dataFiscalizacao:
        execucaoFiscalizacao.dataFiscalizacao == ""
          ? moment().format()
          : moment(execucaoFiscalizacao.dataFiscalizacao).format(
            "YYYY-MM-DD HH:mm"
          ),
      dataHoraPreenchimento: moment().format("YYYY-MM-DD HH:mm"),
      formulario: questoesRespondidas,
    };
    sincronizarFiscalizacao(_execucaoFiscalizacao);
  };

  //Função que retorna o valor do passo ativo
  const getContent = () => {
    switch (steps[activeStep - 1].text) {
      case "Mapa de caçambas":
        return (
          <MapaDeCacambas
            solicitacaoFiscalizacao={solicitacaoFiscalizacao}
            dadosIntegracao={dadosIntegracao}
            loadFormulario={loadFormulario}
            tipoFiscalizacao={tipoFiscalizacao}
            pontosMapa={pontosMapa}
            setActiveStep={setActiveStep}
            setShowButtons={setShowButtons}
          />
        );
      case "Codigo":
        return (
          <Codigo
            tiposDeFiscalizcacao={tiposFiscalizacao}
            solicitacaoFiscalizacao={solicitacaoFiscalizacao}
            loadTipoFiscalizacao={loadTipoFiscalizacao}
            tipoFiscalizacao={tipoFiscalizacao}
            loadIntegracaoPesquisa={loadIntegracaoPesquisa}
            execucaoFiscalizacao={execucaoFiscalizacao}
            setExecucaoFiscalizacao={setExecucaoFiscalizacao}
            errors={errors}
            setErrors={setErrors}
            camposCodigo={camposCodigo}
          />
        );
      case "Identificação do Infrator":
        return (
          <Identificacao
            dadosIntegracao={dadosIntegracao}
            execucaoFiscalizacao={execucaoFiscalizacao}
            setExecucaoFiscalizacao={setExecucaoFiscalizacao}
            errors={errors}
            indicarEndereco={indicarEndereco}
            disabled={solicitacaoFiscalizacao != null}
            solicitacaoImages={solicitacaoImages}
            setDadosIntegracao={setDadosIntegracao}
            disabledCamposDadosFalecido={disabledCamposDadosFalecido}
            exibirDadosObitor={exibirDadosObitor}
          />
        );
      case "Formulário de Fiscalização":
        return (
          <FormularioFiscalizacao
            execucaoFiscalizacao={execucaoFiscalizacao}
            setExecucaoFiscalizacao={setExecucaoFiscalizacao}
            formulario={formulario}
            errors={errors}
            setShowButtons={setShowButtons}
          />
        );
      default:
        return <></>;
    }
  };

  const handleItemFiscalizacao = (rowData) => {
    var _rowData = {
      ...rowData,
      documentoIdentificacao: rowData.documentoIdentificacao.replace(/\D/g, ""),
    };

    loadFormulario(tipoFiscalizacao, _rowData);
    setActiveStep((prev) => prev + 1);
    if (!_rowData.latitude && !_rowData.longitude) setIndicarEndereco(true);

    setListaItensIntegracoes([]);
    toggleModal();
  };

  const actions = [actionsTable.dinamico(faCheck, handleItemFiscalizacao)];

  return (
    <>
      {visibleModal && (
        <ModalCustomized
          size={"lg"}
          toggle={toggleModal}
          widthPadrao={false}
          isOpen={visibleModal}
          btnClose={toggleModal}
          title={"Selecione o Item"}
        >
          <Row>
            <TabelaListagem
              actions={actions}
              options={{ print: false, search: true, pagination: true }}
              headers={headers}
              items={listaItensIntegracoes.map((value) => {
                value.documentoIdentificacao = !!value.documentoIdentificacao
                  ? mascaras.cpfcnpjMask(value.documentoIdentificacao)
                  : value.documentoIdentificacao;
                return value;
              })}
            />
          </Row>
        </ModalCustomized>
      )}

      <Button onClick={handleVoltar}>
        <FontAwesomeIcon icon={faArrowLeft} /> Voltar
      </Button>
      <MainCard>
        <Stepper
          onSubmit={enviarFiscalizacao}
          steps={steps.map((value) => {
            if (value.text.trim() === "Codigo")
              value.validateStep = validarCodigo;
            if (value.text.trim() === "Identificação do Infrator")
              value.validateStep = validarIdentificacao;
            if (value.text.trim() === "Formulário de Fiscalização")
              value.validateStep = validarFormulario;
            return value;
          })}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          showButtons={showButtons}
        >
          <div>{getContent()}</div>
        </Stepper>
      </MainCard>
    </>
  );
}

export default ExecucaoFiscalizacaoStepper;